function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { StyledTwoParagraphsParagraphComponent } from "./two-paragraphs-paragraph-component.scss";
const TwoParagraphsParagraphComponent = (props)=>{
    const { primaryParagraph, secondaryParagraph, alignToLogo, primaryParagraphAdvancedProps, secondaryParagraphAdvancedProps } = props, restProps = _object_without_properties(props, [
        "primaryParagraph",
        "secondaryParagraph",
        "alignToLogo",
        "primaryParagraphAdvancedProps",
        "secondaryParagraphAdvancedProps"
    ]);
    console.log(primaryParagraph);
    return /*#__PURE__*/ _jsx(StyledTwoParagraphsParagraphComponent, {
        className: classnames("two-paragraphs-paragraph-component", {
            "align-to-logo": alignToLogo
        }),
        children: /*#__PURE__*/ _jsx(SideBySideTextAndAsset, _object_spread({
            fullParagraph: _object_spread({}, primaryParagraph),
            replaceAssetComponent: FullParagraph,
            replaceAssetComponentProps: _object_spread({}, secondaryParagraph, secondaryParagraphAdvancedProps),
            asset: {
                position: props.paragraphVerticalAlignment
            },
            alignToLogo: alignToLogo
        }, restProps, primaryParagraphAdvancedProps))
    });
};
export default TwoParagraphsParagraphComponent;
